import * as React from "react";
import { isTabbable } from "tabbable";
import whatInput from "what-input";
const InputContext = React.createContext({
  input: "initial"
});
const InputProvider = (props) => {
  const [input, setInput] = React.useState("initial");
  React.useEffect(() => {
    whatInput.registerOnChange(
      /* istanbul ignore next */
      (nextInput) => {
        setInput((prevInput) => {
          if (prevInput === "keyboard" && nextInput === "mouse" && document.activeElement && isTabbable(document.activeElement)) {
            return prevInput;
          }
          return nextInput;
        });
      },
      "intent"
    );
    setInput(whatInput.ask("intent"));
    return () => whatInput.unRegisterOnChange(setInput);
  }, []);
  const contextValue = React.useMemo(() => ({ input }), [input]);
  return /* @__PURE__ */ React.createElement(InputContext.Provider, { value: contextValue }, props.children);
};
export {
  InputContext,
  InputProvider
};
